import { LayoutGroup } from 'framer-motion';

type NavGroupPanelProps = {
	children: React.ReactNode;
	id: string;
};
const NavGroupPanel = ({ children, id }: NavGroupPanelProps) => {
	return (
		<LayoutGroup id={id}>
			<div className='relative pl-4'>{children}</div>
		</LayoutGroup>
	);
};

export default NavGroupPanel;
